import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  error: "",
  message: "",
};

export const editOfferAction = createAsyncThunk(
  "edit-offer",
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(`/admins/api/editOffer`, { ...data });
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editOfferSlice = createSlice({
  name: "edit-offer",
  initialState,
  reducers: {
    resetEditOfferState: (state) => {
      state.status = null;
      state.loading = false;
      state.data = [];
      state.error = "";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(editOfferAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editOfferAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(editOfferAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const { resetEditOfferState } = editOfferSlice.actions;
export const editOfferReducer = editOfferSlice.reducer;
